<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Community List</h3>
              <router-link :to="{ path: 'community/create' }" class="float-right mt-0">
                <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Community</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title :class="$vuetify.breakpoint.mdAndUp ? 'col-4 float-right' : 'col-12'">
                <v-text-field
                  class="search-text-field"
                  v-model="search"
                  append-icon="search"
                  label="Search by Name"
                  single-line
                  hide-details
                  v-debounce:1s="searchFilter"
                  :debounce-events="['click', 'keydown']"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="float-left width-100"
                :headers="headers"
                :items="communities"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.title`]="{ item }">
                  <div>{{ item.title }}</div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'community/' + item._id }">
                    <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          class="mr-2 edit-icon"
                          src="@/assets/images/Edit.svg" />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>
                  <delete-component
                    :id="item._id"
                    module="community/channel/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2 float-left width-100">
                <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { CommunityService } from "@/services";

export default {
  name: "Community",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: "",
    communities: [],
    headers: [
      {
        text: "Name",
        align: "start",
        value: "title",
      },
      { text: "Description", value: "description" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        title: this.search,
      };
      const CommunityList = await CommunityService.list(params);

      if (CommunityList.data.data.length > 0) {
        this.pageCount = Math.ceil(
          CommunityList.data.option[0].count / this.itemsPerPage
        );
        this.communities = CommunityList.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.communities = [];
      }
    },
    async deleteItem(item) {
      const response = await CommunityService.delete(item._id);
      if (response) {
        this.initialize();
        this.$store.dispatch("user/setSnack", "Community Deleted.");
        this.$store.dispatch("user/setType", "info");
      }
    },
    async handleClick(value) {
      this.$router.push("/community/" + value._id);
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
  },
};
</script>
